import {
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { ITopPageEntry } from "../../types";

interface TopPagesCardProps {
  pages: ITopPageEntry[];
}

export function TopPagesCard({ pages }: TopPagesCardProps) {
  return (
    <Card sx={{ height: "100%" }}>
      <CardContent>
        <Typography variant="subtitle1" fontWeight={600} mb={2}>
          Páginas mais acessadas
        </Typography>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Página</TableCell>
              <TableCell align="right">Sessões</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {pages.map((p) => (
              <TableRow key={p.page}>
                <TableCell sx={{ maxWidth: 200, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                  {p.page}
                </TableCell>
                <TableCell align="right">{p.sessions.toLocaleString("pt-BR")}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}
